
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import "./i18n";
import Counter from "./components/Counter";
import { Head, Header, Footer } from "mdx-deck";
import ChangeLang from "./components/ChangeLang";
import IntlContent from "./components/IntlContent";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Head mdxType="Head">
  <title>My Presentation | @jossdz</title>
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:site" content="@jossdz" />
  <meta name="twitter:title" content="My Presentation" />
  <meta name="twitter:description" content="A really great presentation" />
  <meta name="twitter:image" content="https://example.com/card.png" />
    </Head>
    <Header mdxType="Header">
      <h2>{`i18n slides`}</h2>
    </Header>
    <Footer mdxType="Footer">
  
@jossdz
    </Footer>
    <ChangeLang mdxType="ChangeLang" />
    <IntlContent htmlElement="h1" label="key" mdxType="IntlContent" />
    <Counter mdxType="Counter" />
    <hr></hr>
    <h2>{`this is a mix of markdown and React`}</h2>
    <IntlContent label="list" htmlElement="ul" mdxType="IntlContent" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;